import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { TaskFormFilter } from "../models/task-form-filter.model";
import { CreateTaskResponse, Task, TaskAddModel, TaskTypeToCreate, TaskTypeToList } from "../models/task.model";
import { TaskMessage } from "../models/message.model";
import { MessageFormFilter } from "../models/message-form-filter.model";

export namespace TaskActions {
  @logDispatcher
  export class GetTasks {
    static readonly type = '[Task] GetTasks';
    constructor(public filterModel: TaskFormFilter) { }
  }

  @logDispatcher
  export class GetTasksSuccess {
    static readonly type = '[Task] GetTasksSuccess';
    constructor(public tasks: Task[]) { }
  }

  @logDispatcher
  export class GetMessages {
    static readonly type = '[Task] GetMessages';
    constructor(public filterModel: MessageFormFilter) { }
  }

  @logDispatcher
  export class GetMessagesSuccess {
    static readonly type = '[Task] GetMessagesSuccess';
    constructor(public messages: TaskMessage[]) { }
  }

  @logDispatcher
  export class GetTaskTypesToList {
    static readonly type = '[Task] GetTaskTypesToList';
    constructor() { }

  }
  @logDispatcher
  export class GetTaskTypesToListSuccess {
    static readonly type = '[Task] GetTaskTypesToListSuccess';
    constructor(public taskTypesToList: TaskTypeToList[]) { }
  }

  @logDispatcher
  export class GetTaskTypesToCreate {
    static readonly type = '[Task] GetTaskTypesToCreate';
    constructor() { }

  }
  @logDispatcher
  export class GetTaskTypesToCreateSuccess {
    static readonly type = '[Task] GetTaskTypesToCreateSuccess';
    constructor(public taskTypesToCreate: TaskTypeToCreate[]) { }
  }

  @logDispatcher
  export class AddTask{
    static readonly type = '[Task] AddTask';
    constructor(public task: TaskAddModel, public user: string) { }
  }

  @logDispatcher
  export class AddTaskSuccess{
    static readonly type = '[Task] AddTaskSuccess';
    constructor(public createTaskResponses: CreateTaskResponse[]) { }
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Task] Error';
    constructor(public error: any) {}
  }

  @logDispatcher
  export class SetIsListSmaller {
    static readonly type = '[Task] SetIsListSmaller';
    constructor(public isListSmaller: boolean) {}
  }

  @logDispatcher
  export class SetTaskDefaultState  {
      static readonly type = '[Task] SetTaskDefaultState';
      constructor() {}
  }

  @logDispatcher
  export class SetTaskDefaults  {
      static readonly type = '[Task] SetTaskDefaults';
      constructor() {}
  }
}
